export const appHead = {"meta":[{"name":"viewport","content":"width=device-width, initial-scale=1"},{"charset":"utf-8"}],"link":[],"style":[],"script":[{"innerHTML":"\n            window.bp = window.bp || function () {\n              (window.bp.q = window.bp.q || []).push(arguments);\n            };\n            window.bp.l = 1 * new Date();\n            window.barion_pixel_id = 'BP-QSUFTEYXMq-47';\n            (function () {\n              var script = document.createElement('script');\n              script.async = true;\n              script.src = 'https://pixel.barion.com/bp.js';\n              document.head.appendChild(script);\n            })();\n            bp('init', 'addBarionPixelId', window.barion_pixel_id);\n          "}],"noscript":[],"title":"BNPL"}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"